// extracted by mini-css-extract-plugin
export default {"faqChoiceAgentPage":"faqChoiceAgentPage_ns2Jq","container":"container_NXlLn","breadcrumbs":"breadcrumbs_h9KJ0"};